export default __webpack_public_path__ + "static/media/slider-intro-course.a42a8b03.gif";